<template>
  <coaching-assistant />
  <coaching-assignments-list />
</template>

<script setup lang="ts">
import CoachingAssistant from './TeamLeads/CoachingAssistant.vue';
import CoachingAssignmentsList from './TeamLeads/CoachingAssignmentsList.vue';
</script>
